var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3582 17.8715C13.5487 17.9973 13.7718 18.0643 14 18.0643C14.2282 18.0643 14.4513 17.9973 14.6418 17.8715L21 13.6357V4.30273H7V13.6363L13.3582 17.8715Z",
    stroke: "#344054",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6418 17.8715L22.6918 12.4691C22.8672 12.3535 23.0707 12.2875 23.2806 12.2779C23.4906 12.2684 23.6992 12.3158 23.8844 12.415C24.0696 12.5142 24.2246 12.6617 24.333 12.8417C24.4413 13.0218 24.4991 13.2278 24.5 13.4379V24.1362C24.5 24.4455 24.3771 24.7422 24.1583 24.961C23.9396 25.1798 23.6429 25.3027 23.3335 25.3027H4.66648C4.35711 25.3027 4.06041 25.1798 3.84165 24.961C3.6229 24.7422 3.5 24.4455 3.5 24.1362V13.4844C3.49247 13.2703 3.54402 13.0583 3.64898 12.8716C3.75395 12.6848 3.90829 12.5306 4.09509 12.4257C4.2819 12.3209 4.49396 12.2695 4.70804 12.2771C4.92212 12.2848 5.12997 12.3512 5.3088 12.4691L13.3582 17.8244C13.5441 17.9571 13.7648 18.0323 13.993 18.0405C14.2212 18.0488 14.4468 17.9904 14.6418 17.8715Z",
    stroke: "#306CFE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/emailIcon.441c9426429793e577eed4fcb3bdc586.svg";
export { ForwardRef as ReactComponent };